// env vars
export const APP_ENV = process.env.PUBLIC_APP_ENV;
export const VERSION = process.env.PUBLIC_VERSION;
export const LD_PRODUCTION_KEY = process.env.PUBLIC_LD_PRODUCTION_KEY;
export const DUTCHIE_AGENT_URL = process.env.PUBLIC_DUTCHIE_AGENT_URL;

// app variants
export const IS_DEVELOPMENT_APP = APP_ENV === 'development';
export const IS_PRODUCTION_APP = APP_ENV === 'production';
